{
  "localization.title": "Languages",
  "localization.count": "{count, plural, one {# language} other {# languages}}",
  "localization.tabs_label": "Parts of Languages",
  "localization.tab.coverage": "Coverage",
  "localization.tab.queue": "To review",
  "localization.tab.propose": "Proposals",
  "localization.tab.glossary": "Glossary",
  "localization.rtl": "RTL",
  "localization.test_output": "Test output (not a real translation)",

  "localization.field.title": "Title",
  "localization.field.description": "Description",
  "localization.field.meta_description": "Meta description",
  "localization.field.alt": "Alt text",

  "localization.status.draft": "Draft",
  "localization.status.proposed": "Proposed",
  "localization.status.in_review": "In review",
  "localization.status.approved": "Approved",
  "localization.status.rejected": "Rejected",
  "localization.status.stale": "Outdated",
  "localization.status.superseded": "Replaced",
  "localization.status.missing": "Missing",

  "localization.origin.source": "Source text",
  "localization.origin.human": "Manual",
  "localization.origin.ai": "AI",
  "localization.origin.ai_via": "AI via {provider}",
  "localization.origin.tm": "Translation memory",
  "localization.origin.import": "Import",
  "localization.origin.fixture": "Demo text",

  "localization.mode.published": "Live",
  "localization.mode.preview": "Preview only",
  "localization.mode.off": "Off",

  "localization.web.live": "Live",
  "localization.web.live_incomplete": "Live, {count, plural, one {# listing incomplete} other {# listings incomplete}}",
  "localization.web.ready": "Ready to publish",
  "localization.web.preview": "Preview",
  "localization.web.off": "Off",
  "localization.web.not_on_site": "Not on the website",

  "localization.coverage.live_count": "{count, plural, =0 {No language live yet} one {# language live} other {# languages live}}",
  "localization.coverage.preview_count": "{count, plural, one {# in preview} other {# in preview}}",
  "localization.coverage.site_properties": "{count, plural, one {{n} listing on the website} other {{n} listings on the website}}",
  "localization.coverage.table_label": "Language coverage of {site}",
  "localization.coverage.col_locale": "Language",
  "localization.coverage.col_website": "Website",
  "localization.coverage.col_coverage": "Approved per text",
  "localization.coverage.col_reviewers": "Reviewer",
  "localization.coverage.bar_label": "{field}: {approved} of {total} approved, {pending} in review, {stale} outdated, {missing} missing",
  "localization.coverage.legend": "What the colours mean",
  "localization.coverage.legend_approved": "Approved",
  "localization.coverage.legend_pending": "In review",
  "localization.coverage.legend_stale": "Outdated",
  "localization.coverage.legend_missing": "Missing",
  "localization.coverage.signal_pending": "{count, plural, one {# text waiting for review} other {# texts waiting for review}}",
  "localization.coverage.signal_stale": "{count, plural, one {# text outdated} other {# texts outdated}}",
  "localization.coverage.no_reviewer": "No reviewer",
  "localization.coverage.reviewers": "{first} and {count, plural, one {# other} other {# others}}",
  "localization.coverage.publish": "Publish",
  "localization.coverage.other_title": "Languages outside the website",
  "localization.coverage.other_hint": "Language profiles or translations not yet attached to a website.",
  "localization.coverage.empty_title": "No languages yet",
  "localization.coverage.empty_body": "Add a language to the website to see its coverage.",

  "localization.detail.website": "Website",
  "localization.detail.readiness_loading": "Fetching readiness.",
  "localization.detail.not_on_site": "This language is not on a website yet.",
  "localization.detail.fields": "Texts per field",
  "localization.detail.n_approved": "{n} approved",
  "localization.detail.n_pending": "{n} in review",
  "localization.detail.n_stale": "{n} outdated",
  "localization.detail.n_missing": "{n} missing",
  "localization.detail.no_reviewer_body": "Without a reviewer nobody can approve texts in this language. An admin assigns one in Settings, Team.",
  "localization.detail.publish_when_ready": "You can publish once {count, plural, one {the listing has an approved title and description} other {all {n} listings have an approved title and description}}.",
  "localization.detail.gaps": "{count, plural, one {{n} listing missing text} other {{n} listings missing text}}",
  "localization.detail.to_queue": "Go to the queue",
  "localization.detail.other_title": "Not on the website yet",
  "localization.detail.other_body": "Add this language in Website languages to see per listing what is missing. You can already make proposals.",

  "localization.ready.meter": "Listings complete in {locale}",
  "localization.ready.meter_value": "{complete} of {total}",

  "localization.gaps.label": "Listings with missing texts",
  "localization.gaps.fields_label": "Open fields of {reference}",
  "localization.gaps.no_title": "No title yet",
  "localization.gaps.open": "Listing",
  "localization.gaps.open_label": "Open listing {reference} at its texts",
  "localization.gaps.propose": "Make a proposal",
  "localization.gaps.propose_label": "Make a proposal for {reference}",
  "localization.gaps.more": "{count, plural, =0 {Not every listing is shown here.} one {And # more listing.} other {And # more listings.}}",

  "localization.publish.title": "Publish {locale}",
  "localization.publish.body": "On {site}. Live after the next website publication.",
  "localization.publish.submit": "Publish",
  "localization.publish.to_queue": "Go to the queue",
  "localization.publish.ready_title": "{count, plural, one {The website listing is complete} other {All {n} website listings are complete}}",
  "localization.publish.ready_body": "Title and description are approved in {locale}.",
  "localization.publish.not_ready": "{count, plural, one {{n} listing still lacks approved text in {locale}.} other {{n} listings still lack approved text in {locale}.}}",
  "localization.publish.not_on_site": "{locale} is not on this website yet. Add the language in Website languages first.",
  "localization.publish.blocked_title": "Publishing was refused",
  "localization.publish.blocked_for": "{locale} cannot go live",
  "localization.publish.conflict_title": "Changed in the meantime",
  "localization.publish.conflict_body": "Someone else changed the languages of this website. Refresh and check whether publishing is still needed.",
  "localization.publish.conflict_refresh": "Refresh",
  "localization.publish.done": "{locale} is ready for the website",
  "localization.publish.done_body": "Live after the next website publication.",

  "localization.sitelocales.open": "Website languages",
  "localization.sitelocales.title": "Languages of {site}",
  "localization.sitelocales.body": "Choose per language whether it is live, preview only or off. The order is used for the language menu.",
  "localization.sitelocales.list_label": "Languages and their setting",
  "localization.sitelocales.new": "New on this website",
  "localization.sitelocales.ready": "{count, plural, one {The listing is complete} other {All listings complete}}",
  "localization.sitelocales.not_ready": "{count, plural, one {{n} listing missing text} other {{n} listings missing text}}",
  "localization.sitelocales.mode_label": "Setting for {locale}",
  "localization.sitelocales.up": "Move {locale} up",
  "localization.sitelocales.down": "Move {locale} down",
  "localization.sitelocales.publish_rule": "A language can go live once every website listing has an approved title and description in it.",
  "localization.sitelocales.going_down_title": "Language leaves the website",
  "localization.sitelocales.going_down_body": "After the next publication {locales} is no longer live.",
  "localization.sitelocales.add": "Add language",
  "localization.sitelocales.add_placeholder": "Choose a language",
  "localization.sitelocales.add_hint": "A new language starts in preview.",
  "localization.sitelocales.save": "Save languages",
  "localization.sitelocales.saved": "Languages saved",
  "localization.sitelocales.saved_body": "Visible after the next website publication.",
  "localization.sitelocales.conflict_body": "Someone else changed the languages of this website. Refresh to continue from the latest setting; your changes here are dropped.",

  "localization.queue.list_label": "Texts in the queue",
  "localization.queue.all_locales": "All languages",
  "localization.queue.my_locales": "My languages",
  "localization.queue.locale": "Language",
  "localization.queue.show": "Show",
  "localization.queue.status_review": "To review",
  "localization.queue.status_stale": "Outdated",
  "localization.queue.status_all": "Everything",
  "localization.queue.clear": "Clear filters",
  "localization.queue.you_review": "You review {locales}",
  "localization.queue.read_only_item": "View only: you are not a reviewer for this language",
  "localization.queue.no_review_title": "View only",
  "localization.queue.no_review_body": "A language reviewer approves texts in their language. Here you see what is waiting.",
  "localization.queue.no_locales_title": "No languages assigned yet",
  "localization.queue.no_locales_body": "You have review rights but no languages yet. An admin assigns them in Settings, Team.",
  "localization.queue.empty_title": "Nothing to review",
  "localization.queue.done_title": "All reviewed",
  "localization.queue.empty_body": "New proposals appear here as soon as someone submits a translation or AI makes a proposal.",
  "localization.queue.empty_action": "Make a proposal",
  "localization.queue.empty_filtered_title": "Nothing found",
  "localization.queue.empty_stale_title": "No outdated texts",
  "localization.queue.empty_filtered_body": "Choose another language or status.",

  "localization.keys.browse": "browse",
  "localization.keys.approve": "approve",
  "localization.keys.reject": "reject",
  "localization.keys.ctrl_enter": "Ctrl ↵",

  "localization.review.position": "{n} of {count}",
  "localization.review.position_more": "{n} of {count}+",
  "localization.review.revision": "Revision {n}",
  "localization.review.by_seed": "Demo data",
  "localization.review.prev": "Previous text",
  "localization.review.next": "Next text",
  "localization.review.source": "Source",
  "localization.review.proposal": "Proposal",
  "localization.review.translation": "Translation",
  "localization.review.marks_hint": "Numbers are highlighted so you can compare them with the source. Red is a critical mismatch, orange a warning.",
  "localization.review.current_version": "View the current approved version",
  "localization.review.checked_at": "Fact check run on {when}.",
  "localization.review.test_body": "The test adapter does not translate: it only puts a test label in front of the source text. Approving is not possible; reject or send it back.",
  "localization.review.stale_title": "Outdated",
  "localization.review.stale_source_hint": "Make a new proposal based on the new source.",
  "localization.review.stale_facts_hint": "If the text still matches the new details, you can approve it again.",
  "localization.review.new_proposal": "Make a new proposal",
  "localization.review.decision": "Decision",
  "localization.review.approve": "Approve",
  "localization.review.reapprove": "Approve again",
  "localization.review.approve_confirms": "Approving confirms that you read source and proposal in full.",
  "localization.review.reject": "Reject",
  "localization.review.request_changes": "Send back",
  "localization.review.reject_hint": "The proposal is dropped; a new proposal is needed.",
  "localization.review.request_hint": "The proposal goes back as a draft, with your reason.",
  "localization.review.reject_submit": "Reject",
  "localization.review.request_submit": "Send back",
  "localization.review.reasons": "Common reasons",
  "localization.review.reason_facts": "Facts do not match the listing.",
  "localization.review.reason_tone": "Tone or style does not fit the website.",
  "localization.review.reason_incomplete": "Translation is incomplete.",
  "localization.review.reason_test": "Test output, not a real translation.",
  "localization.review.note": "Reason",
  "localization.review.note_hint": "Stored with this version and visible to whoever made the proposal.",
  "localization.review.note_required": "Give a reason.",
  "localization.review.cannot_approve": "Cannot approve",
  "localization.review.cannot_decide": "Cannot review",
  "localization.review.blocked_test": "Test output cannot be approved.",
  "localization.review.blocked_qa": "The fact check found a critical mismatch.",
  "localization.review.blocked_source": "The source text changed; make a new proposal first.",
  "localization.review.not_allowed_title": "You cannot approve {locale}.",
  "localization.review.not_allowed_locale": "You only review {locales}.",
  "localization.review.not_allowed_none": "No languages are assigned to you yet.",
  "localization.review.not_allowed_role": "Your role {role} has no review rights.",
  "localization.review.reviewers": "Reviewers for this language: {names}.",
  "localization.review.no_reviewers": "This language has no reviewer yet; an admin assigns one in Settings, Team.",
  "localization.review.not_reviewable": "Status: {status}. This version can no longer be reviewed.",
  "localization.review.conflict_title": "Already reviewed or replaced",
  "localization.review.conflict_body": "Someone else got there first, or there is a newer proposal. The queue was refreshed.",
  "localization.review.done_approve": "Approved",
  "localization.review.done_reject": "Rejected",
  "localization.review.done_request_changes": "Sent back",
  "localization.review.failed_approve": "Approving did not work",
  "localization.review.failed_reject": "Rejecting did not work",
  "localization.review.failed_request_changes": "Sending back did not work",

  "localization.qa.title": "Fact check",
  "localization.qa.unchecked": "Not checked",
  "localization.qa.unchecked_body": "No fact check was stored for this version.",
  "localization.qa.ok": "Facts match",
  "localization.qa.ok_body": "Numbers, areas, prices and references match the listing details. Numbers written out in words are not recognised; check those yourself.",
  "localization.qa.critical": "{count, plural, one {# critical mismatch} other {# critical mismatches}}",
  "localization.qa.warnings": "{count, plural, one {# warning} other {# warnings}}",
  "localization.qa.severity_critical": "Critical:",
  "localization.qa.severity_warning": "Note:",
  "localization.qa.found": "Found: {value}.",
  "localization.qa.expected": "Expected: {value}.",
  "localization.qa.unknown_value": "unknown",
  "localization.qa.forbidden_term": "forbidden glossary term: {term}.",
  "localization.qa.numbers_found": "Numbers in the text:",
  "localization.qa.issue.fact_bedrooms_mismatch": "number of bedrooms differs.",
  "localization.qa.issue.fact_bathrooms_mismatch": "number of bathrooms differs.",
  "localization.qa.issue.fact_bedrooms_partial": "number of bedrooms is part of the total stated in the text.",
  "localization.qa.issue.fact_bathrooms_partial": "number of bathrooms is part of the total stated in the text.",
  "localization.qa.issue.fact_area_mismatch": "area is not in the listing details.",
  "localization.qa.issue.fact_area_part": "area of a part (terrace, garden, floor, buildable area) next to an area stated correctly in the text.",
  "localization.qa.issue.fact_year_mismatch": "year built differs.",
  "localization.qa.issue.fact_unknown_number": "number that is not in the listing details.",
  "localization.qa.issue.fact_price_in_text": "price in the text. Prices belong in the details, not in free text.",
  "localization.qa.issue.fact_reference_mismatch": "a different reference than this listing.",
  "localization.qa.issue.text_html_not_allowed": "HTML is not allowed in the text.",
  "localization.qa.issue.text_placeholder_mismatch": "placeholders differ from the source.",
  "localization.qa.issue.text_empty": "the text is empty.",

  "localization.fact.kind": "property type",
  "localization.fact.bedrooms": "bedrooms",
  "localization.fact.bathrooms": "bathrooms",
  "localization.fact.builtM2": "built area",
  "localization.fact.usableM2": "usable area",
  "localization.fact.plotM2": "plot",
  "localization.fact.terraceM2": "terrace",
  "localization.fact.yearBuilt": "year built",
  "localization.fact.locality": "town",
  "localization.fact.municipality": "municipality",
  "localization.fact.views": "views",
  "localization.fact.features": "features",
  "localization.fact.energyRating": "energy rating",
  "localization.fact.touristLicense": "tourist licence",
  "localization.fact.floorLevel": "floor",
  "localization.fact.price": "price",

  "localization.stale.source_changed": "The source text changed.",
  "localization.stale.facts_changed": "Listing details changed: {facts}.",
  "localization.stale.unknown": "Reason unknown.",

  "localization.propose.property": "Listing",
  "localization.propose.property_placeholder": "Search by reference or title",
  "localization.propose.no_title": "No title yet",
  "localization.propose.field": "Text",
  "localization.propose.target": "Target language",
  "localization.propose.target_placeholder": "Choose a language",
  "localization.propose.start_title": "Choose a listing",
  "localization.propose.start_body": "Then choose the text and the target language. The source sits next to your proposal.",
  "localization.propose.no_unit_title": "No source text",
  "localization.propose.no_unit_body": "This listing has no source text for {field} yet. Write it on the listing first.",
  "localization.propose.facts_hint": "Copy numbers, prices and areas unchanged. The fact check compares them with the listing details.",
  "localization.propose.pick_target": "Choose a target language to start.",
  "localization.propose.current": "Now:",
  "localization.propose.no_current": "No version in this language yet",
  "localization.propose.current_is_test": "The current version is test output from the AI test adapter. Write the real translation here.",
  "localization.propose.replaces_review": "A new proposal replaces the proposal now in review.",
  "localization.propose.keeps_approved": "The approved text stays live until your new proposal is approved.",
  "localization.propose.text_label": "Translation in {locale}",
  "localization.propose.count": "{count, plural, one {# character} other {# characters}}",
  "localization.propose.count_title": "{count, plural, one {# character} other {# characters}}, guideline for titles is 120",
  "localization.propose.submit": "Submit proposal",
  "localization.propose.ai": "Request AI proposal",
  "localization.propose.ai_test": "Request test proposal",
  "localization.propose.ai_tip": "The result arrives as a proposal in the queue. Nothing is published.",
  "localization.propose.ai_test_tip": "The test adapter makes test output to try the flow, not a translation.",
  "localization.propose.ai_test_hint": "The test adapter runs locally: it does not translate and only makes test output.",
  "localization.propose.ai_hint": "Via {provider}. The result arrives as a proposal in the queue.",
  "localization.propose.ai_off": "AI is off.",
  "localization.propose.ai_budget_reached": "This month's AI budget is used up.",
  "localization.propose.budget": "Budget this month: {spent} of {limit}.",
  "localization.propose.no_ai_right": "AI proposals need the right to use AI.",
  "localization.propose.test_adapter": "the test adapter",
  "localization.propose.base_mismatch_title": "Different base version",
  "localization.propose.base_mismatch_reload": "Load current version",
  "localization.propose.sent": "Proposal submitted",
  "localization.propose.sent_ok": "Fact check: no critical mismatches.",
  "localization.propose.sent_critical": "Fact check: critical mismatch found.",
  "localization.propose.result_title": "Proposal is in the queue",
  "localization.propose.result_body": "A reviewer for {locale} reviews it. Nothing was published.",
  "localization.propose.result_critical_title": "Proposal submitted, but blocked",
  "localization.propose.result_critical_body": "The fact check found a critical mismatch. A reviewer cannot approve this; adjust the text and submit again.",
  "localization.propose.ai_tm_title": "Reused from translation memory",
  "localization.propose.ai_tm_body": "An approved translation of exactly this source text already existed. It is now a proposal in the queue for {locale}.",
  "localization.propose.ai_test_title": "Test output (not a real translation)",
  "localization.propose.ai_test_body": "The test adapter put a test label in front of the source. It is in the queue so you can test the flow; it cannot be approved.",
  "localization.propose.ai_title": "AI proposal in the queue",
  "localization.propose.ai_body": "{provider} made a proposal for {locale}. A reviewer reviews it; nothing was published.",
  "localization.propose.ai_critical": "The fact check found a critical mismatch.",
  "localization.propose.ai_tm_toast": "Translation reused",
  "localization.propose.ai_test_toast": "Test output made (not a real translation)",
  "localization.propose.ai_toast": "AI proposal made",
  "localization.propose.ai_toast_body": "It is a proposal in the queue.",
  "localization.propose.to_queue": "Go to the queue",
  "localization.propose.conflict_title": "There is a newer version",
  "localization.propose.conflict_body": "Another version in this language arrived since you started. Choose which text continues.",
  "localization.propose.conflict_latest": "Latest version",
  "localization.propose.conflict_mine": "Your text",
  "localization.propose.conflict_unsent": "Not submitted",
  "localization.propose.conflict_load": "Load latest version",
  "localization.propose.conflict_submit": "Submit my text",
  "localization.propose.conflict_removed": "The version you started from no longer exists.",
  "localization.propose.matrix_title": "All languages of {reference}",
  "localization.propose.matrix_field": "Text",
  "localization.propose.matrix_pick": "{field} in {locale}: {status}. Open",
  "localization.propose.no_rights_title": "No rights for proposals",
  "localization.propose.no_rights_body": "Ask an admin for the right to propose translations.",

  "localization.glossary.add": "Add term",
  "localization.glossary.add_title": "Add term",
  "localization.glossary.edit_title": "Edit term",
  "localization.glossary.edit_label": "Edit {term}",
  "localization.glossary.all_locales": "All languages",
  "localization.glossary.any_use": "All",
  "localization.glossary.locale": "Language",
  "localization.glossary.locale_placeholder": "Choose a language",
  "localization.glossary.search": "Search the glossary",
  "localization.glossary.search_placeholder": "Concept, term or note",
  "localization.glossary.col_locale": "Language",
  "localization.glossary.col_term": "Term",
  "localization.glossary.col_status": "Use",
  "localization.glossary.col_note": "Note",
  "localization.glossary.status": "Use",
  "localization.glossary.status_preferred": "Preferred",
  "localization.glossary.status_allowed": "Allowed",
  "localization.glossary.status_forbidden": "Forbidden",
  "localization.glossary.status_preferred_hint": "Use this term. Included in AI requests.",
  "localization.glossary.status_allowed_hint": "Allowed, without preference.",
  "localization.glossary.status_forbidden_hint": "Blocks approval when the term appears in a text.",
  "localization.glossary.concept": "Concept",
  "localization.glossary.concept_hint": "Lowercase letters, digits, dot and underscore, for example kind.finca.",
  "localization.glossary.concept_invalid": "Use only lowercase letters, digits, dot and underscore.",
  "localization.glossary.term": "Term",
  "localization.glossary.note": "Note",
  "localization.glossary.dialog_body": "Applies to this organisation. New proposals are checked against the updated list.",
  "localization.glossary.read_only": "A language reviewer manages terms.",
  "localization.glossary.added": "{term} added",
  "localization.glossary.updated": "{term} updated",
  "localization.glossary.deleted": "{term} deleted",
  "localization.glossary.delete_title": "Delete {term}?",
  "localization.glossary.delete_body": "New proposals are checked without this term. Existing translations do not change.",
  "localization.glossary.delete_confirm": "Delete term",
  "localization.glossary.empty_title": "No terms yet",
  "localization.glossary.empty_body": "Record fixed translations, for example that finca does not become farm.",
  "localization.glossary.empty_filtered_title": "No terms found",
  "localization.glossary.empty_filtered_body": "Choose another language or search term."
}
